import type { UserSubscriptionSummary } from '@/types/subscription';

/**
 * Helper that returns whether a subcsription is active. Currently, only "ACTIVE" state is considered an active subscription.
 */
export function hasActiveSubscription(subscription?: UserSubscriptionSummary): boolean {
  return subscription?.status === 'ACTIVE';
}
